// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2EyQ8","messages":"Chat_messages__cao68","dateDivider":"Chat_dateDivider__24O60"};